<template>
  <div class="footer-activity-container">
    <div class="swiper" ref="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide activity-item">
          <img class="avatar-frame" :src="imageList.frame" />
          <div class="activity-info">
            <div class="title">领取限量版头像框和成就</div>
            <div class="desc">累计5天完成投票可以领取</div>
          </div>
          <div class="lottery-btn">去领取</div>
        </div>

        <div class="swiper-slide activity-item">
          <img class="cdkey" :src="imageList.cdkey" />
          <div class="activity-info">
            <div class="title">抽取100份年度游戏CDKEY</div>
            <div class="desc">投票完成后并分享即可参加抽奖</div>
          </div>
          <div class="lottery-btn">去分享</div>
        </div>

        <div class="swiper-slide activity-item">
          <img class="emoji-cube" :src="imageList.emoji" />
          <div class="activity-info">
            <div class="title">参与社区讨论瓜分丰厚奖励</div>
            <div class="desc">2000余额 600万H币 100份CUBE盲袋</div>
          </div>
          <div class="lottery-btn">去讨论</div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import {
  getUrlParam,
  executeProtocol,
  executeProtocolOutApp,
} from '_lib/utils';
import { openWindow } from '../../assets/js/jump';
import Swiper, { Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
Swiper.use([Pagination, Autoplay]);

export default {
  props: {
    awardList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mySwiper: null,
      isInApp: this.$hb_env.is_inapp,
      imageList: {
        frame:
          'https://imgheybox.max-c.com/oa/2024/11/19/4f588e2e88294e91429c43859e253b68.png',
        cdkey:
          'https://imgheybox.max-c.com/oa/2024/11/12/0169de7f977d89b3b3ba9996c68b52cc.png',
        emoji:
          'https://imgheybox.max-c.com/oa/2024/11/12/e5c80dc0185ab1dd942310cd2a389802.png',
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  methods: {
    initSwiper() {
      this.mySwiper = new Swiper(this.$refs['swiper'], {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        on: {
          click: (swiper) => {
            const realIndex = swiper.realIndex;
            switch(realIndex) {
              case 0: 
                this.goActivityPage()
                return
              case 1: 
                this.handleShare()
                return
              case 2:
                this.handleDiscuss()
                return
              default: 
                return
            }
          }
        }
      });
    },
    goActivityPage() {
      openWindow('/activity/tga_2024/publicity', {
        act_id: getUrlParam('act_id'),
      });
    },
    handleShare() {
      let votedAward = this.awardList.find((item) => item.my_result);
      if (votedAward) {
        this.$emit('vote', votedAward);
      } else {
        this.$emit('vote', this.awardList[0]);
      }
    },
    handleDiscuss() {
      let protocol = {
        protocol_type: 'openRouterPath',
        path: 'bbs/link',
        params: {
          link_id: '138810095',
          link_tag: 11,
        },
      };
      this.isInApp
        ? executeProtocol(protocol)
        : executeProtocolOutApp(protocol);
    },
  },
};
</script>

<style lang="less">
.footer-activity-container {
  z-index: 1000;
  width: 100%;
  height: 88px;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #232425;
  .activity-item {
    height: 88px;
    padding: 0 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .avatar-frame {
      height: 62px;
      width: 62px;
      flex-shrink: 0;
    }
    .cdkey {
      height: 50px;
      width: 54px;
      flex-shrink: 0;
    }
    .emoji-cube {
      width: 48px;
      flex-shrink: 0;
    }
    .activity-info {
      margin: 0 10px;
      flex: 1;
      .title {
        color: #e0e0e0;
        font-family: 'PingFang SC';
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      }
      .desc {
        margin-top: 4px;
        color: #8c9196;
        font-family: 'PingFang SC';
        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
      }
    }
    .lottery-btn {
      width: 76px;
      height: 32px;
      flex-shrink: 0;
      border-radius: 3px;
      background: #3c63af;
      color: #fff;
      font-family: 'PingFang SC';
      font-size: 14px;
      font-weight: 600;
      line-height: 32px;
      text-align: center;
    }
  }
  .swiper {
    .swiper-pagination {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      .swiper-pagination-bullet {
        width: 8px;
        height: 2px;
        margin: 0 3px;
        border-radius: 1px;
        background: rgba(255, 255, 255, 0.4);

        &.swiper-pagination-bullet-active {
          background: rgba(255, 255, 255);
        }
      }
    }
  }
}
</style>
